var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal go-modal-detail fade show",
        staticStyle: { display: "block", "overflow-y": "scroll" },
        attrs: {
          id: "go-detail-report",
          "data-backdrop": "static",
          tabindex: "-1",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "go-detail-container" }, [
                _c("div", { staticClass: "go-detail-toolbar" }, [
                  _c("div", { staticClass: "go-fixed-box" }, [
                    _c("div", { staticClass: "go-btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-icon",
                          attrs: { type: "button" },
                          on: { click: _vm.closeDetail },
                        },
                        [_vm._m(0)]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-detail-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "go-detail go-detail-summary",
                      staticStyle: { width: "100%" },
                    },
                    [
                      _c("div", { staticClass: "go-detail-header" }, [
                        _c("div", { staticClass: "go-block-top" }, [
                          _vm.i18nBriefingNamePath !== ""
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "go-detail-label go-detail-label-default",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t(_vm.i18nBriefingNamePath))
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "go-detail-label go-detail-label-default",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getCompanyWidgetDetail.name || ""
                                    )
                                  ),
                                ]
                              ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "go-detail-title",
                            staticStyle: { "word-break": "keep-all" },
                          },
                          [_vm._v(_vm._s(_vm.detailData.title || ""))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-block-bottom" }, [
                          _c("div", { staticClass: "go-info-inline" }, [
                            _c("span", { staticClass: "go-channel" }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("span", { staticClass: "go-channel-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "publicNotificationSummaryDetail.channelName"
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-info-inline" }, [
                            _vm.detailData.publishDate
                              ? _c(
                                  "span",
                                  { staticClass: "go-info-item go-datetime" },
                                  [
                                    _c("i", {
                                      staticClass: "go-icon-18 go-icon-time",
                                    }),
                                    _vm._v(" "),
                                    _c("em", { staticClass: "go-text" }, [
                                      _vm._v(
                                        _vm._s(_vm.detailData.publishDate || "")
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-detail-body" }, [
                        _c("div", { staticClass: "go-section-main" }, [
                          _c(
                            "p",
                            { staticStyle: { "word-break": "keep-all" } },
                            [_vm._v(_vm._s(_vm.detailData.content || ""))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-section-reference" }, [
                          _c("div", { staticClass: "go-scetion-header" }, [
                            _c("div", { staticClass: "go-scetion-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "publicNotificationSummaryDetail.referenceText"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-section-body" }, [
                            _vm.detailData.references &&
                            _vm.detailData.references.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "go-reference-list" },
                                  _vm._l(
                                    _vm.detailData.references,
                                    function (reference, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: "reference" + index,
                                          staticClass: "go-list-item",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "go-card-sub" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "go-card-body" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-card-title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          reference.title || ""
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-card-desc",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                  " +
                                                          _vm._s(
                                                            reference.description ||
                                                              ""
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-card-info",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "go-info-item go-channel",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "go-channel-thumb",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    reference.faviconImage ||
                                                                    "content/images/images_v3/sample/@sample-media-1.png",
                                                                  alt: "",
                                                                },
                                                                on: {
                                                                  error:
                                                                    _vm.onErrorFaviconReference,
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "go-channel-name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  reference.publisher ||
                                                                    ""
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      reference.publishedDate
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "go-info-item go-datetime",
                                                              staticStyle: {
                                                                "padding-left":
                                                                  "20px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  reference.publishedDate ||
                                                                    ""
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "go-card-footer",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn go-btn-icon",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.handleOpenReferenceUrl(
                                                            reference.url || ""
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "go-tooltip-area",
                                                          attrs: {
                                                            id:
                                                              "referenceUrlPopover" +
                                                              index,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "go-icon-20 go-icon-newwindow",
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-popover",
                                                        {
                                                          attrs: {
                                                            target:
                                                              "referenceUrlPopover" +
                                                              index,
                                                            triggers: "hover",
                                                            placement: "top",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                    " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "companyDetailCommon.referencePopoverText"
                                                                )
                                                              ) +
                                                              "\n                                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-detail-footer" }, [
                        _c("div", { staticClass: "go-content-owner" }, [
                          _vm.detailData.briefingInfo.name
                            ? _c(
                                "a",
                                {
                                  staticClass: "go-title",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleClickBriefingName.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.detailData.briefingInfo.name) +
                                      "\n                      "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "go-info-inline",
                              attrs: { "aria-disabled": _vm.isLoadingSubcribe },
                            },
                            [
                              _vm.detailData.userProfile
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "go-info-item go-user-info",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.onSelectUserSocial(
                                            _vm.detailData.userProfile
                                              .userKey || ""
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.detailData.userProfile.avatarImageUrl
                                        ? _c(
                                            "div",
                                            { staticClass: "go-user-thumb" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.detailData
                                                    .userProfile.avatarImageUrl,
                                                  alt: "",
                                                },
                                                on: {
                                                  error: _vm.onErrorImageAvatar,
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.detailData.userProfile.lastName
                                        ? _c(
                                            "a",
                                            { staticClass: "go-user-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.detailData.userProfile
                                                    .lastName || ""
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "go-info-item go-count" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.detailData.briefingInfo
                                          .subcribeCount
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(
                                        _vm.$t(
                                          "publicNotificationSummaryDetail.subscribers"
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-elements" }, [
                          _c(
                            "button",
                            {
                              class: [
                                "btn go-btn-subscribe",
                                { active: _vm.subscribeStatus === "SUBSCRIBE" },
                              ],
                              attrs: {
                                type: "button",
                                "data-toggle": "button",
                                "aria-pressed": "true",
                                disabled: _vm.isLoadingSubcribe,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleSubscribed()
                                },
                              },
                            },
                            [
                              _vm.subscribeStatus === "SUBSCRIBE"
                                ? [
                                    _c(
                                      "span",
                                      { staticClass: "go-toggle-on" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "go-icon-18 go-icon-subscribe-on",
                                        }),
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "publicNotificationSummaryDetail.subscribing"
                                            )
                                          ) + "\n                          "
                                        ),
                                      ]
                                    ),
                                  ]
                                : [
                                    _c(
                                      "span",
                                      { staticClass: "go-toggle-off" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "go-icon-18 go-icon-subscribe",
                                        }),
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "publicNotificationSummaryDetail.subscribe"
                                            )
                                          ) + "\n                          "
                                        ),
                                      ]
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "go-detail-aside",
                    staticStyle: { width: "660px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "go-fixed-box",
                        staticStyle: { width: "660px" },
                      },
                      [
                        _c("div", { staticClass: "go-panel go-panel-aside" }, [
                          _c(
                            "div",
                            { staticClass: "go-panel-body" },
                            [
                              _c("ask-goover", {
                                attrs: {
                                  page: _vm.PAGES.COMPANY_BRIEFING_WIDGET,
                                  "reference-documents": [
                                    {
                                      title: _vm.detailData.title,
                                      content: _vm.detailData.content,
                                      url:
                                        _vm.detailData.references[0] &&
                                        _vm.detailData.references[0].url,
                                    },
                                  ],
                                  stockCode: _vm.stockCode,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "modal-backdrop fade show",
      staticStyle: { "z-index": "1030 !important" },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "go-tooltip-area",
        attrs: {
          "data-toggle": "tooltip",
          "data-placement": "left",
          title: "Close",
        },
      },
      [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-channel-thumb" }, [
      _c("img", {
        attrs: {
          src: "content/images/images_v3/common/go-goover-symbol.png",
          alt: "goover",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }